import React from "react";
import { ShieldCheck } from "lucide-react";
import { downloadApps } from "../data/apps";
import DownloadCards from "../components/DownloadCards";
import { DownloadsHeader, DownloadsHero } from "../components/downloads/DownloadsTop";
import { CompatibilitySection } from "../components/downloads/CompatibilitySection";
import { InstallSteps, InstallHelp, DownloadsFooter } from "../components/downloads/InstallSections";

const formatDownloads = (n) => n.toLocaleString("pt-BR");

const PlatformDownloads = () => (
  <section className="max-w-[1400px] mx-auto px-6 pb-12" data-testid="downloads-platforms">
    <div className="flex items-center justify-center gap-2 mb-6 text-xs font-bold uppercase tracking-widest text-silver/70">
      <ShieldCheck className="w-4 h-4 text-brand-2" /> Escolha sua plataforma
    </div>
    <DownloadCards />
    <p className="mt-5 text-center text-xs text-silver/50">
      APK Android: {formatDownloads(downloadApps[0].downloads)} downloads • Versão oficial mais recente
    </p>
  </section>
);

export default function Downloads() {
  return (
    <div className="min-h-screen bg-ink text-white">
      <DownloadsHeader />
      <DownloadsHero />
      <PlatformDownloads />
      <CompatibilitySection />
      <InstallSteps />
      <InstallHelp />
      <DownloadsFooter />
    </div>
  );
}
